module.exports = __webpack_public_path__ + "static/logo-pwc-cutup-12336f20b5f317c61bb42d84e1ec28c1.svg";